import React from 'react';

const loader = (props) => (
	<div className='loader'>
		<div className='loader__content'>
			<i className='fas fa-calculator'></i>
			<p>Loading</p>
		</div>
	</div>
);

export default loader;


// WEBPACK FOOTER //
// ./src/UI/Loader.js